import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import TechStack from "../components/TechStack";
import Industries from "../components/Industries";
import CTA from "../components/CTA";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About/>
      <Services />
      <TechStack/>
      <Industries/>      
      <CTA />
      <Contact />
      <Footer/>
    </>
  );
}

export default App;
